module.exports = __webpack_public_path__ + "img/2.30472265.png";